import React from 'react'
import { withIcon } from '../../withIcon'

function FlagIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.625 5.27294V12.7359C6.48785 12.2228 7.47984 11.9457 8.5 11.9457C9.97236 11.9457 11.386 12.523 12.4375 13.5536C13.2553 14.3552 14.3548 14.8043 15.5 14.8043C16.5598 14.8043 17.5805 14.4197 18.375 13.727V6.26404C17.5121 6.7771 16.5202 7.05425 15.5 7.05425C14.0276 7.05425 12.614 6.47696 11.5625 5.4463C10.7447 4.64469 9.64517 4.19568 8.5 4.19568C7.4402 4.19568 6.4195 4.58024 5.625 5.27294ZM5.625 14.2729C6.4195 13.5802 7.4402 13.1957 8.5 13.1957C9.64517 13.1957 10.7447 13.6447 11.5625 14.4463C12.614 15.477 14.0276 16.0543 15.5 16.0543C16.9724 16.0543 18.386 15.477 19.4375 14.4463C19.5574 14.3288 19.625 14.1679 19.625 14V4.99996C19.625 4.74831 19.4741 4.52121 19.2421 4.42374C19.01 4.32628 18.7422 4.37747 18.5625 4.55363C17.7447 5.35524 16.6452 5.80425 15.5 5.80425C14.3548 5.80425 13.2553 5.35524 12.4375 4.55363C11.386 3.52297 9.97236 2.94568 8.5 2.94568C7.02764 2.94568 5.61397 3.52297 4.5625 4.55363C4.44258 4.67117 4.375 4.83204 4.375 4.99996V21C4.375 21.3451 4.65482 21.625 5 21.625C5.34518 21.625 5.625 21.3451 5.625 21V14.2729Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FlagIcon)
